import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormInput from '../../components/form/FormInput';

import {
  setActiveHelpDetails,
  useActiveHelpDetails,
  whatsappAddDetails,
  whatsappEditDetails
} from '../../store/slices/tenantSlices/helpDeskSlice';
import { cleanPhoneNumber } from '../../utils/common';
import { useTranslation } from 'react-i18next';

const AddEditNumberModal = ({ isOpen, onCloseClick, isEdit = false, editRecord = null }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeHelpDetails = useActiveHelpDetails();

  const initialValues = {
    name: '',
    from: ''
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('name is required'),
    from: Yup.string().required('number is required')
  });

  const onSubmit = async () => {
    if (isEdit) {
      try {
        const payload = {
          name: values?.name,
          ticketId: editRecord.ticketId,
          from: `91${values?.from}@c.us`
        };
        const response = await dispatch(whatsappEditDetails(payload)).unwrap();
        if (response && response?.message) {
          dispatch(setActiveHelpDetails({ ...activeHelpDetails, name: values?.name }));
          toast.success('Record Updated Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      try {
        const payload = { ...values, from: `91${values?.from}@c.us` };
        const response = await dispatch(whatsappAddDetails(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Added Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...values,
        name: editRecord?.name,
        from: editRecord?.from ? cleanPhoneNumber(editRecord?.from) : ''
      });
    }
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{isEdit ? t('editName') : t('addNumber')}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="crms" onSubmit={handleSubmit}>
          <Row>
            <Col lg="12" md="12">
              <FormInput
                name="name"
                label={t('name')}
                placeholder="Enter Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="12" md="12">
              <FormInput
                name="from"
                label={t('number')}
                placeholder="Enter Number"
                value={values.from}
                onChange={(e) => {
                  const value = e.target.value;
                  const val = value.replace(/[^0-9*#]+/g, '');
                  setFieldValue('from', val);
                }}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          {t('cancel')}
        </Button>
        <Button form="crms" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? t('update') : t('save')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditNumberModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditNumberModal;
